import { render, staticRenderFns } from "./Compare.vue?vue&type=template&id=528086a2&scoped=true&"
import script from "./Compare.vue?vue&type=script&lang=js&"
export * from "./Compare.vue?vue&type=script&lang=js&"
import style0 from "./Compare.vue?vue&type=style&index=0&id=528086a2&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "528086a2",
  null
  
)

export default component.exports